import route from './route';

export default {
  route,
};
